import SimpleWrapper from "../components/SimpleWrapper";
import UIWrapper from "../components/UIWrapper";

const AccountInfoDeletion = () => {
    return (
      <div className="bg-white flex flex-col justify-center items-start px-4 max-w-2xl mx-auto pt-[2%]">
        <h1 className="text-lg lg:text-2xl font-bold text-center">Delete Your Fine Labs Account</h1>
          <h2>App name: Fine Labs</h2>
          <h2 className="mb-6">Developer Name: Fine Labs Developer</h2>
          <p className="text-gray-700 mb-4 ">
          If you no longer wish to use our services and would like to delete your Fine Labs account, you can do so at any time. Deleting your account will permanently remove your personal data from our systems and cannot be undone.
          </p>
          <h2 className="text-xl font-semibold mb-3">Steps to Request Account Deletion</h2>
          <ol className="list-decimal pl-5 mb-4 text-gray-700">
          <li className="mb-1">Log in to your Fine Labs app using your registered account.</li>
          <li className="mb-1">Go to the <strong>Profile</strong> section.</li>
          <li className="mb-1">Select the <strong>Edit profile icon</strong></li>
          <li className="mb-1">Tap on the <strong>Delete Account</strong> button.</li>
          <li className="mb-1">A confirmation popup will appear. Tap <strong>Delete Account</strong> to proceed.</li>
          </ol>

          <h2 className="text-xl font-semibold mb-3">What Happens After Deletion?</h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li className="mb-4">Your account and associated data will be permanently deleted</li>
          </ul>


          <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
          <p className="mb-2 text-gray-700">If you have any questions about the process, feel free to contact our support team:</p>
          <a 
            href="mailto:support@finelabs.in" 
            className="text-blue-600 hover:underline flex justify-start mb-[1%]"
          >
            support@finelabs.in
          </a>
      </div>
    )
}


export default AccountInfoDeletion;